import * as React from 'react';
import { Button, DropdownPopover, Outside } from '@cian/ui-kit';
import { RangeInput } from '../../../RangeInput';
import * as styles from './Price.css';
import { getPriceLabel } from './utils/getPriceLabel';
import { useEventCallback } from '@cian/react-utils';

interface IPriceProps {
  value: {
    min: number | null | undefined;
    max: number | null | undefined;
  };
  onChange({ min, max }: { min: number | undefined; max: number | undefined }): void;
}

export const Price: React.VFC<IPriceProps> = ({ value, onChange }) => {
  const buttonRef = React.useRef<HTMLButtonElement>(null);
  const contentRef = React.useRef<HTMLDivElement>(null);

  const [open, setOpen] = React.useState(false);

  const label = getPriceLabel(value.min ?? null, value.max ?? null);

  const handleChange = useEventCallback((min: number | undefined, max: number | undefined) => {
    onChange({ min, max });
  });

  return (
    <Outside onOutside={() => setOpen(false)} insideRefs={[buttonRef, contentRef]}>
      <DropdownPopover
        open={open}
        content={
          <div ref={contentRef} className={styles['content']}>
            <RangeInput
              maxWidth={272}
              min={0}
              max={1000000000}
              valueMin={value.min ?? undefined}
              valueMax={value.max ?? undefined}
              onChange={handleChange}
              postfix="₽"
            />
          </div>
        }
      >
        <Button
          ref={buttonRef}
          onClick={() => setOpen(!open)}
          size="XS"
          theme="stroke_secondary"
          type="button"
          aria-label="Цена"
        >
          {label || 'Цена'}
        </Button>
      </DropdownPopover>
    </Outside>
  );
};
